const InfoAvailabilities = {
    standard: 'Standard',
    optional: 'Optional'
};

export default InfoAvailabilities
